export default "/pt-weeth.3cfa864aab94d9817fa0340cdc6e9409.svg";